import { render, staticRenderFns } from "./StatementDescriptor.vue?vue&type=template&id=75be2448&scoped=true&"
import script from "./StatementDescriptor.vue?vue&type=script&lang=js&"
export * from "./StatementDescriptor.vue?vue&type=script&lang=js&"
import style0 from "./StatementDescriptor.vue?vue&type=style&index=0&id=75be2448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be2448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75be2448')) {
      api.createRecord('75be2448', component.options)
    } else {
      api.reload('75be2448', component.options)
    }
    module.hot.accept("./StatementDescriptor.vue?vue&type=template&id=75be2448&scoped=true&", function () {
      api.rerender('75be2448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/StatementDescriptor.vue"
export default component.exports